'use strict';

require('./educationStatus');
require('./educationDiscipline');
require('./educationQualificationGroup');
require('../partners/partners');
require('../../helpers/users/users.module');

angular.module('far.models.education.education', [
        'far.models.education.status',
        'far.models.partners',
        'far.models.education.userType',
        'far.models.education.discipline',
        'far.helpers.users'
    ])
    .service('education', function ($log, $rootScope, $http, educationStatus, educationQualificationGroup, educationDiscipline, partners, usersHelper) {
        this.new = function (eventData, userTypes) {
            return new Education(eventData, userTypes);
        };

        this.get = function (eventId, userTypes, callback) {
            var event = new Education({}, userTypes);

            $http.get(Routing.generate('api_event_get_event', {id: eventId}))
                .then(function (response) {
                    if (!response.data.background_image) {
                        delete response.data.background_image;
                    }

                    event.update(response.data);

                    event.type = event.type.id;

                    event.event_education.accepted = {id: event.event_education.accepted};

                    event.event_education.participants = {
                        min: event.event_education.participants_count_from,
                        max: event.event_education.participants_count_to
                    };

                    var partnersWatch = $rootScope.$watch(function () {
                        return partners.list.length;
                    }, function (length) {
                        if (length > 0) {
                            var event_partners_length = event.partners.length;

                            if (event_partners_length) {
                                partners.list.forEach(function (partner) {
                                    if (length == event_partners_length) {
                                        partner.selected = true;
                                    } else {
                                        event.partners.forEach(function (selectedPartner) {
                                            if (partner.id == selectedPartner.id) {
                                                partner.selected = true;
                                            }
                                        });
                                    }
                                });

                                partnersWatch();
                            }
                        }
                    });

                    if (typeof callback == 'function') {
                        callback(event);
                    }
                })
                .catch(function (response) {
                    $log.error(response);
                });

            return event;
        };

        function Education(eventData, userTypes) {
            if (!eventData.event_education) {
                eventData.event_education = {
                    documents: {},
                    users: [],
                    users_complite: [],
                    participants: {
                        min: 1,
                        max: 500
                    }
                }
            }

            angular.merge(this, eventData);

            Object.defineProperty(this, 'update', {
                enumerable: false,
                get: function () {
                    return function (eventData) {
                        if (eventData.event_education.documents_files) {
                            delete this.event_education.documents_files;
                        }

                        /*
                        fix AFFEB-11 После пересохранения любого ранее созданного меропрития, участники
                        
                        var users = this.event_education.users;

                        users.forEach(function (u, index) {
                            eventData.event_education.users.forEach(function (ud) {
                                if (ud.event_education_user_type.system_name === u.event_education_user_type.system_name) {
                                    users[index] = ud;
                                }
                            });
                        });

                        eventData.event_education.users = users; */

                        angular.merge(this, eventData);

                        this.event_education.updateUsers();
                    }
                }
            });

            Object.defineProperty(this, 'save', {
                enumerable: false,
                get: function () {
                    return function () {
                        var method = this.id ? 'put' : 'post',
                            url = this.id ?
                                Routing.generate('api_event_put_event', {event: this.id}) :
                                Routing.generate('api_event_post_event');

                        // Могу преобразовывать data как хочу.
                        var data = angular.extend({}, this);

                        if (angular.isObject(data.event_education.accepted)) {
                            data.event_education.accepted = data.event_education.accepted.id;
                        }

                        if (angular.isObject(data.event_education.club)) {
                            data.event_education.club = data.event_education.club.id;
                        }

                        if (angular.isObject(data.camp)) {
                            data.camp = data.camp.id;
                        }

                        data.event_education.participants_count_from = data.event_education.participants.min;
                        data.event_education.participants_count_to = data.event_education.participants.max;

                        delete data.event_education.participants;

                        data.partners = data.partners.filter(function (partner) {
                            return partner.selected;
                        }).map(function (partner) {
                            return partner.id;
                        });

                        if (data.background_image && data.background_image.length > 0) {
                            data.background_image = data.background_image.filter(function (image) {
                                return angular.isDefined(image.serverData)
                            }).map(function (image) {
                                return image.serverData;
                            });

                            data.background_image = data.background_image.length > 0 ? data.background_image[0].id : undefined;
                        }

                        if (data.event_education.documents_files && data.event_education.documents_files.length > 0) {
                            data.event_education.documents_files = data.event_education.documents_files.filter(function (documentFile) {
                                return angular.isDefined(documentFile.serverData);
                            }).map(function (documentFile) {
                                return documentFile.serverData.id;
                            });
                        }

                        data.event_education.users = data.event_education.users.filter(function (value) {
                            return angular.isObject(value.user);
                        });

                        data.event_education.documents = Object.keys(data.event_education.documents).map(function (key) { return data.event_education.documents[key].id; });

                        return $http[method](url, data);
                    }
                }
            });

            usersHelper.initUsers(this.event_education, userTypes, 'users', 'event_education_user_type');

            this.event_education.createUser(this.event_education.userTypes.user_safety);
            this.event_education.createUser(this.event_education.userTypes.user_coach);
            this.event_education.createUser(this.event_education.userTypes.user_chief);


        }
    });
